import './index.scss'
import * as React from 'react';
import { Box, Stepper, Step, StepLabel, Button, StepIcon } from '@mui/material';
import { styled } from '@mui/system';
import { get } from '../../util/request';
import { userInfo } from '../../redux/slice';
import { useSelector } from 'react-redux';
import CoverLetter from '../exitVoting/coverLetter/index.js'
import ExitOfferReturns from '../exitVoting/exitOfferReturns/index.js'
import ExitBallot from '../exitVoting/exitBallot/index.js'
import KYC from '../exitVoting/kyc/index.js'
import NFC from '../exitVoting/nfc/index.js'
import ExitSummary from '../exitVoting/exitSummary/index.js'
import Loading from '../../components/common/loading.js'
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import SubmitSuccessPopUp from '../../components/page/submitSuccessPopUp';

export default ExitVotingStepper; function ExitVotingStepper() {
  const { t } = useTranslation();
  const history = useHistory();
  const [steps, setSteps] = React.useState([]);
  const [completedSteps, setCompletedSteps] = React.useState(new Set());
  const user = useSelector(userInfo);
  const [activeStep, setActiveStep] = React.useState(0);
  const [nextButtonStatus, setNextButtonStatus] = React.useState(true);
  const [votingResult, setVotingResult] = React.useState([]);
  const [votingDetails, setVotingDetails] = React.useState({ usResident: false, usStateName: '', citizenship: '', recId: sessionStorage.getItem('recId'), residencyID: '', taxFilingOption: '', usaResident: '', faqurl: '', udiCountry: '', canadianTaxFiling: '' });
  const [exitTemplate, setExitTemplate] = React.useState('');
  const previewDetail = JSON.parse(sessionStorage.getItem('previewDetail'));
  const votingTemplate = JSON.parse(sessionStorage.getItem('votingTemplate'));
  const recId = sessionStorage.getItem('recId');
  const [loading, setLoading] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [businessDetail, setBusinessDetail] = React.useState({ occupation: '', addressLine1: '', addressLine2: '', businessPhone: '', businessEmail: '' });

  const getHTML = async (fileType) => {
    setExitTemplate('');
    setLoading(true);
    let htmlTemplate = '';

    switch (fileType) {
      case 'COVER LETTER':
        htmlTemplate = votingTemplate?.coverLetter ?? ''
        break;
      case 'EXIT OFFER RETURNS':
        htmlTemplate = votingTemplate?.exitOfferReturns ?? ''
        break;
      case 'EXIT BALLOT':
      case 'EO-BLT':
        htmlTemplate = votingTemplate?.exitBallot ?? ''
        break;
      case 'KYC':
      case 'EO-KYC':
        htmlTemplate = votingTemplate?.kyc ?? ''
        break;
      case 'NFC':
      case 'P-NFC':
        htmlTemplate = votingTemplate?.nfc ?? ''
        break;
      case 'W8':
      case 'P-W8B':
        htmlTemplate = votingTemplate?.w8 ?? ''
        break;
      case 'W9':
      case 'P-W9':
        htmlTemplate = votingTemplate?.w9 ?? ''
        break;
      case 'DOR':
      case 'EO-DOR':
        htmlTemplate = votingTemplate?.dor ?? ''
        break;
      case 'EPC':
      case 'EO-EPC':
        htmlTemplate = votingTemplate?.epc ?? ''
        break;
      case 'IDP':
      case 'EO-IDP':
        htmlTemplate = votingTemplate?.idp ?? ''
        break;
      default:
        break;
    }

    if (htmlTemplate !== '' && votingTemplate?.headerRecId === recId) {
      setExitTemplate(htmlTemplate);
      setIsModalOpen(false);
      setLoading(false);
      setIsError(false);
    }
    else {
      const params = {
        accessToken: user.accessToken,
        userId: user.userId,
        fileType: fileType, headerRecId: recId, accountNum: user.sfUserType === 'IR' ? previewDetail?.clientId : user.clientID,
        mobile: false
      }
      await get('exitVoting/template', params).then((data) => {
        if (data) {
          const existingTemplate = JSON.parse(sessionStorage.getItem('votingTemplate')) || {};
          switch (fileType) {
            case 'COVER LETTER':
              if (votingDetails.udiCountry === 'USA') {
                if (votingDetails.citizenship === '' || votingDetails.residencyID === '' || votingDetails.taxFilingOption === ''
                  || (votingDetails.usaResident === 'Resident' && votingDetails.usStateName === '')
                  || ((votingDetails.citizenship === 'United States' || votingDetails.residencyID === 'United States') && votingDetails.usaResident === 'Non-Resident')) {
                  existingTemplate.coverLetter = '';
                }
                else {
                  existingTemplate.coverLetter = data;
                }
              }
              else {
                // if (votingDetails.canadianTaxFiling === '') {
                //   existingTemplate.coverLetter = '';
                // }
                // else {
                //   existingTemplate.coverLetter = data;
                // }
                existingTemplate.coverLetter = data;
              }
              break;
            case 'EXIT OFFER RETURNS':
              existingTemplate.exitOfferReturns = data;
              break;
            case 'EXIT BALLOT':
            case 'EO-BLT':
              existingTemplate.exitBallot = data;
              break;
            case 'KYC':
            case 'EO-KYC':
              if (votingDetails.udiCountry === 'USA') {
                if (votingDetails.citizenship === '' || votingDetails.residencyID === '' || votingDetails.taxFilingOption === ''
                  || (votingDetails.usaResident === 'Resident' && votingDetails.usStateName === '')
                  || ((votingDetails.citizenship === 'United States' || votingDetails.residencyID === 'United States') && votingDetails.usaResident === 'Non-Resident')) {
                  existingTemplate.kyc = '';
                }
                else {
                  existingTemplate.kyc = data;
                }
              }
              else {
                // if (votingDetails.canadianTaxFiling === '') {
                //   existingTemplate.kyc = '';
                // }
                // else {
                //   existingTemplate.kyc = data;
                // }
                existingTemplate.kyc = data;
              }
              break;
            case 'NFC':
            case 'P-NFC':
              if (votingDetails.udiCountry === 'USA') {
                if (votingDetails.citizenship === '' || votingDetails.residencyID === '' || votingDetails.taxFilingOption === ''
                  || (votingDetails.usaResident === 'Resident' && votingDetails.usStateName === '')
                  || ((votingDetails.citizenship === 'United States' || votingDetails.residencyID === 'United States') && votingDetails.usaResident === 'Non-Resident')) {
                  existingTemplate.nfc = '';
                }
                else {
                  existingTemplate.nfc = data;
                }
              }
              else {
                // if (votingDetails.canadianTaxFiling === '') {
                //   existingTemplate.nfc = '';
                // }
                // else {
                //   existingTemplate.nfc = data;
                // }
                existingTemplate.nfc = data;
              }
              break;
            case 'W8':
            case 'P-W8B':
              existingTemplate.w8 = data;
              break;
            case 'W9':
            case 'P-W9':
              existingTemplate.w9 = data;
              break;
            case 'DOR':
            case 'EO-DOR':
              existingTemplate.dor = data;
              break;
            case 'EPC':
            case 'EO-EPC':
              existingTemplate.epc = data;
              break;
            case 'EO-IDP':
            case 'IDP':
              existingTemplate.idp = data;
              break;
            default:
              break;
          }
          existingTemplate.headerRecId = recId;
          sessionStorage.setItem('votingTemplate', JSON.stringify(existingTemplate));
          setExitTemplate(data);

          setIsModalOpen(false);
          setLoading(false);
          setIsError(false);
        }
      }).catch(() => {
        setIsModalOpen(true);
        setLoading(false);
        setIsError(true);
      });
    }
  }


  const CustomStepIcon = styled(StepIcon)(({ theme }) => ({
    width: 37,
    height: 37,
    '& .MuiStepIcon-circle': {
      width: 37,
      height: 37,
      borderRadius: '50%'
    },
  }));

  const setup = async () => {
    if (recId !== null || recId !== undefined) {
      let params = {
        accessToken: user.accessToken,
        userId: user.userId,
        accountNum: user.sfUserType === 'IR' ? previewDetail?.clientId : user.clientID,
        headerRecId: recId
      }
      await get('exitVoting/exitProcessHeader', params).then((data) => {
        if (data.usaResident === 'Resident') {
          setVotingDetails(prevData => ({
            ...prevData,
            usResident: true,
            usStateName: data.usStateName
          }));
        }

        setVotingDetails(prevData => ({
          ...prevData,
          citizenship: data.citizenship,
          residencyID: data.residencyID,
          taxFilingOption: data.taxFilingOption,
          usaResident: data.usaResident,
          faqurl: data.faqurl,
          udiCountry: data?.udiCountry,
          canadianTaxFiling: data?.canadianTaxFiling
        }));

        setBusinessDetail(prevData => ({
          ...prevData,
          businessEmail: data?.exitVotingTemplateDTO?.BusinessEmail,
          businessPhone: data?.exitVotingTemplateDTO?.BusinessPhone,
          addressLine1: data?.exitVotingTemplateDTO?.BusinessAddress1,
          addressLine2: data?.exitVotingTemplateDTO?.BusinessAddress2,
          occupation: data?.exitVotingTemplateDTO?.Occupation,
        }));

        const newSteps = data?.exitVotingDocument?.map(x => x.documentName);
        setSteps(newSteps);
      });
    }
  }

  //#region Exit ballot funtion
  const handleExitBallot = (data) => {
    setVotingResult(data);
  };
  //endregion

  const handleNext = () => {
    if (activeStep < steps.length) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      const newCompletedSteps = new Set(completedSteps);
      newCompletedSteps.add(activeStep);
      setCompletedSteps(newCompletedSteps);
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => {
    if (completedSteps.has(step)) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setActiveStep(step);
    }
  };

  React.useEffect(() => {
    if (votingTemplate?.headerRecId !== recId) {
      sessionStorage.removeItem('votingTemplate');
    }
    setup();
  }, []);


  React.useEffect(() => {
    exitBallotNextCheck();
  }, [votingResult, exitTemplate]);

  const exitBallotNextCheck = () => {
    if (activeStep === steps.indexOf('EXIT BALLOT')) { //Exit ballot
      setTimeout(() => {
        const wrapper = document.getElementById('exit-ballot-div');
        if (wrapper !== null) {
          const offerCount = Array.from(new Set(Array.from(wrapper.querySelectorAll('input')).map(radio => radio.name))).length;
          if ((votingResult.length === offerCount) && votingResult.length > 0 && offerCount > 0) {
            setNextButtonStatus(false);
          }
        }
      }, 100);
    }
  };

  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    if (activeStep === steps.indexOf('COVER LETTER')) {
      getHTML('COVER LETTER');
      checkButtonNext();
    }
    else if (activeStep === steps.indexOf('EXIT OFFER RETURNS')) {
      setNextButtonStatus(false);
    }
    else if (activeStep === steps.indexOf('EXIT BALLOT')) {
      getHTML('EO-BLT');
      setNextButtonStatus(true);
      exitBallotNextCheck();
    }
    else if (activeStep === steps.indexOf('KYC')) {
      getHTML('EO-KYC');
      checkButtonNext();
    }
    else if (activeStep === steps.indexOf('NFC')) {
      getHTML('P-NFC');
      checkButtonNext();
    }
    else if (activeStep === steps.indexOf('W8')) {
      getHTML('P-W8B');
      setNextButtonStatus(false);
    }
    else if (activeStep === steps.indexOf('W9')) {
      getHTML('P-W9');
      setNextButtonStatus(false);
    }
    else if (activeStep === steps.indexOf('DOR')) {
      getHTML('EO-DOR');
      setNextButtonStatus(false);
    }
    else if (activeStep === steps.indexOf('EPC')) {
      getHTML('EO-EPC');
      setNextButtonStatus(false);
    }
    else if (activeStep === steps.indexOf('IDP')) {
      getHTML('EO-IDP');
      setNextButtonStatus(false);
    }
  }, [activeStep, steps]);

  const handleOk = () => {
    history.push({
      pathname: user.sfUserType === 'IR' ? '/preview/home' : '/home'
    });
  }

  const handleContactUs = () => {
    history.push({
      pathname: user.sfUserType === 'IR' ? '/preview/contactUs' : '/contactUs'
    });
  }

  const handleBusinessDetailChange = (key, value) => {
    setBusinessDetail(prevData => ({
      ...prevData,
      [key]: value
    }));
  }

  React.useEffect(() => {
    if (activeStep === steps.indexOf('KYC')) {
      const emailRegex = /^(?:|[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})$/;
      if (emailRegex.test(businessDetail.businessEmail)) {
        setNextButtonStatus(false);
      }
      else {
        setNextButtonStatus(true);
      }
    }
  }, [businessDetail])

  const checkButtonNext = () => {
    const hasMissingInfoUSA = (votingDetails.citizenship === '' || votingDetails.residencyID === '' || votingDetails.taxFilingOption === ''
      || (votingDetails.usaResident === 'Resident' && votingDetails.usStateName === '')
      || ((votingDetails.citizenship === 'United States' || votingDetails.residencyID === 'United States') && votingDetails.usaResident === 'Non-Resident'));

    const hasMissingInfoCAN = false; //votingDetails?.canadianTaxFiling === '';
    setNextButtonStatus(votingDetails.udiCountry === 'USA' ? hasMissingInfoUSA : hasMissingInfoCAN);
  }

  return ((user.sfUserType === 'CL' || (user.sfUserType === 'IR' && sessionStorage.getItem('previewDetail') !== null)) && (<>
    {loading && <Loading />}
    <div className='exit-voting'>
      <SubmitSuccessPopUp isModalOpen={isModalOpen} title={isError ? 'ERROR' : t('submissionSuccessful')} content={isError ? t('UNEXPECTED_ERROR_desc') : ''} handleOk={handleOk} handleCancel={handleContactUs} icon={isError ? 'submit-error' : 'submit-success'} confirmText={t('Confirm')} />
      <div className='exit-voting-stepper'>
        <Box sx={{ width: '1446px' }}>
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label, index) => {
              const stepProps = {};
              const labelProps = {};

              if (completedSteps.has(index) && activeStep !== index) {
                stepProps.completed = true;
              }


              return (
                <Step key={label} {...stepProps} onClick={() => handleStep(index)}>
                  <StepLabel {...labelProps} StepIconComponent={index === activeStep ? CustomStepIcon : null}>{t(label)}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
          {//Summary Tab
            activeStep === steps.length ? (
              <>
                {
                  steps.length > 0 ? (<>
                    <React.Fragment>
                      <div className='stepper-content'>
                        <ExitSummary VotingDetails={votingDetails} VotingResult={votingResult} BusinessDetail={businessDetail} />
                      </div>
                    </React.Fragment>
                  </>) : <Loading />
                }
              </>
            ) : (
              <React.Fragment>
                <div className='stepper-content'>
                  {//Cover letter Tab
                    activeStep === steps.indexOf('COVER LETTER') && (<>
                      <CoverLetter
                        Template={exitTemplate}
                        VotingDetails={votingDetails}
                      />
                    </>)
                  }
                  {//Exit offer return Tab
                    activeStep === steps.indexOf('EXIT OFFER RETURNS') && (<>
                      <ExitOfferReturns Template={exitTemplate} Step={"EXIT OFFER RETURNS"} />
                    </>)
                  }
                  {//Exit Ballot Tab
                    activeStep === steps.indexOf('EXIT BALLOT') && (<>
                      <ExitBallot
                        Template={exitTemplate}
                        VotingResult={votingResult}
                        handleExitBallotSave={handleExitBallot}
                        headerRecId={recId}
                      />
                    </>)
                  }
                  {//KYC Tab
                    activeStep === steps.indexOf('KYC') && (<>
                      <KYC
                        Template={exitTemplate}
                        HandleBusinessDetailSave={handleBusinessDetailChange}
                        UDICountry={votingDetails?.udiCountry}
                        BusinessDetail={businessDetail}
                      />
                    </>)
                  }

                  {//NFC Tab
                    activeStep === steps.indexOf('NFC') && (<>
                      <NFC Template={exitTemplate} headerRecId={recId} />
                    </>)
                  }

                  {//Exit offer return Tab
                    activeStep === steps.indexOf('W8') && (<>
                      <ExitOfferReturns Template={exitTemplate} Step={"W8"} />
                    </>)
                  }
                  {//Exit offer return Tab
                    activeStep === steps.indexOf('W9') && (<>
                      <ExitOfferReturns Template={exitTemplate} Step={"W9"} />
                    </>)
                  }
                  {//Exit offer return Tab
                    activeStep === steps.indexOf('DOR') && (<>
                      <ExitOfferReturns Template={exitTemplate} Step={"DOR"} />
                    </>)
                  }
                  {//Exit offer return Tab
                    activeStep === steps.indexOf('EPC') && (<>
                      <ExitOfferReturns Template={exitTemplate} Step={"EPC"} />
                    </>)
                  }
                  {//Exit offer return Tab
                    activeStep === steps.indexOf('IDP') && (<>
                      <ExitOfferReturns Template={exitTemplate} Step={"IDP"} />
                    </>)
                  }
                </div>
                <div className='stepper-footer'>
                  <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                    <Button
                      color="inherit"
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      sx={{ mr: 1 }}
                      id='back-button'
                    >
                      {t('BACK')}
                    </Button>
                    <Box sx={{ flex: '1 1 auto' }} />
                    <Button onClick={handleNext} disabled={nextButtonStatus} id='next-button'>
                      {activeStep === steps.length - 1 ? t('REVIEW AND SIGN') : t('NEXT')}
                    </Button>
                  </Box>
                </div>
              </React.Fragment>
            )}
        </Box>
      </div>
    </div>
  </>));
}
